import React from 'react';

export default function Feature({ title, description, steps, className, icon, image }) {
  return (
    <div className={`px-[16px] py-[48px] lg:py-[96px] lg:px-[96px] ${className}`}>
      <div className="mb-[24px]">{icon}</div>
      <div>
        <h1 className="text-dark text-30 font-altone_b leading-[38px] mb-[16px]">{title}</h1>
        {description && (
          <p className="text-18 text-[#667085] font-dmsans_r leading-[28px]">{description}</p>
        )}
        {image}
      </div>
      {steps && (
        <ul className='font-dmsans_r text-18 text-grey leading-7 pl-4 list-decimal'>
          {steps?.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
